import React, { useState } from "react";
import { LogoHorizontal } from "../../components/library/logos";
import "./welcomePage.scss";
import MobileHeroPhone from "../../assets/nota-reimagined/mobile-hero-phone@2x.png";
import FeatureExploration from "../../assets/nota-reimagined/exploration@2x.png";
import FeatureGuides from "../../assets/nota-reimagined/guides@2x.png";
import FeatureAudioMode from "../../assets/nota-reimagined/audio-mode@2x.png";
import FeatureTrails from "../../assets/nota-reimagined/trails@2x.png";
import FeatureBuiltAroundYou from "../../assets/nota-reimagined/built-around-you@2x.png";
import DesktopPhone1 from "../../assets/nota-reimagined/desktop-phone-1.svg";
import DesktopPhone2 from "../../assets/nota-reimagined/desktop-phone-2.svg";
import DesktopPhone3 from "../../assets/nota-reimagined/desktop-phone-3.svg";
import HeroPolygon from "../../assets/nota-reimagined/hero-polygon.svg";
import { useScrollPosition } from "../../hooks/useScrollPosition";
import AppStoreLink from "../../components/appStoreLink/appStoreLink";
import Loader from "../../components/loader/loader";
import { CustomIconEnvelope } from "../../components/library/icons";
import { submitEmailToNotaReimaginedMailingList } from "../../api/apiClient";
import NatureBackground from "../../assets/nota-reimagined/nature-background-dark.jpg";

const NotaReimagined = () => {
  const posUp = useScrollPosition(-0.1);
  const url =
    process.env.REACT_APP_ENV === "production"
      ? "https://admin.mynota.io/public-chat"
      : "https://staging.admin.mynota.io/public-chat";

  const [submitting, setSubmitting] = useState(false);
  const [submissionResult, setSubmissionResult] = useState<
    "success" | "failed" | null
  >(null);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setSubmitting(true);
    const { email } = Object.fromEntries(new FormData(event.target));
    const res = await submitEmailToNotaReimaginedMailingList(email as string);
    setSubmitting(false);
    console.log(res);

    if (res.success) {
      setSubmissionResult("success");
    } else {
      setSubmissionResult("failed");
    }
  };

  return (
    <div className="welcome-page">
      <section className="hero-section">
        <div className="hero-background">
          <img src={NatureBackground} />
        </div>
        <div id="mobileFloater1" className="floater mobile red"></div>
        <div className="hero-white-triangle"></div>
        <div className="container">
          {/* <div className="logo-container">
            <LogoHorizontal color={"white"} />
          </div> */}
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="uppercase">
                <p>Welcome to Nota</p>
                The App That Walks Through Life With You.
              </h1>
              <p>Download Today</p>
              <div className="button-wrap">
                <AppStoreLink type="ios" />
                <AppStoreLink type="android" />
              </div>
            </div>
            {/* <div className="hero-images">
              <div className="mobile-hero-image">
                <img src={MobileHeroPhone} />
              </div>
              <div className="desktop-hero-image">
                <img
                  className="bg-polygon floatingVertical"
                  src={HeroPolygon}
                />
                <div className="phones">
                  <img src={DesktopPhone1} />
                  <img src={DesktopPhone2} />
                  <img src={DesktopPhone3} />
                </div>
              </div>
            </div> */}
            <div className="video-container">
              <video
                className="video-mobile"
                autoPlay
                muted
                loop
                controls
                width="220"
                height="477.02"
              >
                <source
                  src="https://player.vimeo.com/progressive_redirect/playback/1101894533/rendition/720p/file.mp4?loc=external&log_user=0&signature=acd66826105d0a578269212278625ed861ae7095ea06a8695f305b5fa698a50e"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <video
                className="video-desktop"
                autoPlay
                muted
                loop
                controls
                width="250"
                height="542.06"
              >
                <source
                  src="https://player.vimeo.com/progressive_redirect/playback/1101894533/rendition/720p/file.mp4?loc=external&log_user=0&signature=acd66826105d0a578269212278625ed861ae7095ea06a8695f305b5fa698a50e"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>
      <section className="preview-section" style={{ marginTop: posUp - 120 }}>
        <div id="mobileFloater2" className="floater mobile red"></div>
        <div id="mobileFloater3" className="floater mobile blue"></div>
        <div id="mobileFloater4" className="floater mobile yellow"></div>
        {/* <div
          id="floater1"
          className="floater desktop medium red floatingHorizontal"
        ></div>
        <div
          id="floater2"
          className="floater desktop small yellow floatingVertical"
        ></div> */}
        <div id="floater3" className="floater desktop large red"></div>
        <div id="floater4" className="floater desktop large yellow"></div>
        <div
          id="floater5"
          className="floater desktop medium red floatingHorizontal"
        ></div>
        <div
          id="floater6"
          className="floater desktop small yellow floatingVertical"
        ></div>
        <div id="floater7" className="floater desktop large yellow"></div>
        <div id="floater8" className="floater desktop medium red"></div>
        <div id="floater9" className="floater desktop medium red"></div>
        <div className="preview-header">
          <p>Jump In</p>
          <h2 className="uppercase">
            Every Journey Matters.
            <br />
            Start Yours Today.
          </h2>
          {/* <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              required
            ></input>
            <button
              type="submit"
              disabled={submitting || submissionResult === "success"}
            >
              {submitting ? (
                <div style={{ display: "flex" }}>
                  <Loader />
                </div>
              ) : (
                <span className="submit-button" style={{ display: "flex" }}>
                  Join Waitlist&nbsp;
                  <CustomIconEnvelope size={10} />
                </span>
              )}
            </button>
          </form> */}
          {submissionResult === "success" && (
            <p style={{ margin: "1rem 0 0", fontSize: "1rem" }}>
              Submission success! Thanks for joining the waitlist!
            </p>
          )}
          {submissionResult === "failed" && (
            <p style={{ margin: "1rem 0 0", fontSize: "1rem" }}>
              There was a problem submitting your email.
            </p>
          )}
        </div>
        <p className="get-excited-for">Get Excited For</p>
        <div className="feature-grid">
          <div>
            <div className="feature-image dark">
              <img src={FeatureExploration} />
            </div>
            <div className="feature-text">
              <p className="title">Free Exploration</p>
              <p className="description">
                Like exploring a new forest, path, or city, Nota lets you
                explore the topics that matter most—at your own pace, in your
                own way.
              </p>
            </div>
          </div>
          <div>
            <div className="feature-image light">
              <img src={FeatureGuides} />
            </div>
            <div className="feature-text">
              <p className="title">Interactive Guides</p>
              <p className="description">
                Walk alongside fun, thoughtful AI guides who offer insights, ask
                questions, and help you reflect on life and faith in meaningful
                ways.
              </p>
            </div>
          </div>
          <div>
            <div className="feature-image light">
              <img src={FeatureAudioMode} />
            </div>
            <div className="feature-text">
              <p className="title">Audio Mode</p>
              <p className="description">
                Nota is there for you, even in the car or on a dirt trail.
                Enable audio mode to listen to content no matter where you are.
              </p>
            </div>
          </div>
          <div>
            <div className="feature-image light">
              <img src={FeatureTrails} />
            </div>
            <div className="feature-text">
              <p className="title">Trails</p>
              <p className="description">
                Each trail in Nota leads you through transformative topics—from
                purpose and identity to faith and relationships—designed to meet
                you right where you are.
              </p>
            </div>
          </div>
          <div>
            <div className="feature-image dark">
              <img src={FeatureBuiltAroundYou} />
            </div>
            <div className="feature-text">
              <p className="title">Built Around You</p>
              <p className="description">
                Nota adapts to your story—offering encouragement, challenges,
                and insights that speak directly to your season of life.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="landing-chat-section">
        <h2>Try It Out!</h2>
        <div className="iframe-container">
          <iframe
            src={url}
            width="100%"
            height={window.innerHeight}
            style={{ border: "none" }}
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default NotaReimagined;
